import React from 'react';
import { ImageList, ImageListItem, useMediaQuery } from '@mui/material';
import { innovyzeTheme } from '@innovyze/stylovyze';
import { MediaInspections } from '@Types';
import missingImage from './missing.png';

// Internal component — not exported from lib-am-common barrel.

interface InspectionPhotoSectionProps {
	images: MediaInspections[];
	onImageClick: (url: string) => void;
	failedIds: Set<string>;
	onImageError: (key: string) => void;
}

export const InspectionPhotoSection = ({
	images,
	onImageClick,
	failedIds,
	onImageError,
}: InspectionPhotoSectionProps): JSX.Element | null => {
	const isMD = useMediaQuery(innovyzeTheme.breakpoints.up('md'));
	const isLG = useMediaQuery(innovyzeTheme.breakpoints.up('lg'));
	const isXL = useMediaQuery(innovyzeTheme.breakpoints.up('xl'));

	if (images.length === 0) return null;

	const columns = () => {
		if (isXL) return 5;
		if (isLG) return 4;
		if (isMD) return 3;
		return 1;
	};

	return (
		<ImageList
			rowHeight={120}
			style={{ width: '98%', paddingTop: '12px', overflow: 'hidden' }}
			cols={columns()}>
			{images.map(img => {
				const thumbUrl = img.imageLocation || missingImage;
				const key = `insp:${img.mediaId}`;
				const isFailed = failedIds.has(key) || !img.imageLocation;
				return (
					<ImageListItem
						key={img.mediaId}
						cols={1}
						className={'inspectionPhoto'}
						onClick={isFailed ? undefined : () => onImageClick(thumbUrl)}
						style={{ cursor: isFailed ? 'default' : 'pointer' }}>
						<div
							style={{
								height: '100px',
								width: '100px',
								margin: '0 auto',
								background: 'center',
								backgroundSize: 'cover',
								backgroundImage: `url(${thumbUrl}), url(${missingImage})`,
							}}
						/>
						<img
							src={thumbUrl}
							alt=""
							style={{ display: 'none' }}
							onError={() => onImageError(key)}
						/>
					</ImageListItem>
				);
			})}
		</ImageList>
	);
};
